module.exports = __webpack_public_path__ + "img/icon-eye-off.f5cda24b.svg";